var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.collection.name)+" ")]),_c('v-card-text'),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"primary","text":""}},[_vm._v(" Drucken ")]),_c('v-btn',{attrs:{"color":"primary","text":""}},[_vm._v(" Schließen ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }